import { 
  collection, 
  getDocs, 
  getDoc, 
  doc, 
  query, 
  where,
} from "firebase/firestore";
import { db } from "../lib/firebase";

const docToShipping = (id, data) => ({
  id,
  name: data.name,
  type: data.type, // BY_WEIGHT, FIXED
  price: data.price,
  isActive: data.isActive !== false,
  isDeleted: data.isDeleted || false,
});

export const getShippingCharges = async (activeOnly = true) => {
  const constraints = [where("isDeleted", "==", false)];
  if (activeOnly) constraints.push(where("isActive", "==", true));
  
  const q = query(collection(db, "shippingCharges"), ...constraints);
  const snap = await getDocs(q);
  return snap.docs.map(d => docToShipping(d.id, d.data()));
};

export const getShippingChargeById = async (id) => {
  if (!id) return null;
  const d = await getDoc(doc(db, "shippingCharges", id));
  if (!d.exists()) return null;
  return docToShipping(d.id, d.data());
};
